import React from 'react';
import styled from 'styled-components';

// Create a Wrapper component that'll render a <section> tag with some styles
const StyledCentered = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
`;

const Centered = (props) => (<StyledCentered>{props.children}</StyledCentered>);

export default Centered;


// WEBPACK FOOTER //
// ./src/Components/Centered.js